/**
 * Dev-only fixture lookup. The require sits in a branch webpack proves false in
 * production, so states.js is dropped from the bundle. A top-level import is
 * not enough - it was shipping.
 */
export default function mockRequest(id, enabled) {
  if (process.env.NODE_ENV !== 'development' || !enabled) return null
  // eslint-disable-next-line
  const { MOCK_STATES } = require('./states')
  return MOCK_STATES[id] || null
}
